// Same host as TRANSLATION_API_URL in constants/api.js (LAN-1114). Kept inline:
// the Cartus reading tests load this file as a module with no imports.
const CONSUMER_TRANSLATION_URL = 'https://translation.languatalk.com';

export function serverMediatedPage() {
  if (typeof document === 'undefined' || typeof window === 'undefined') return false;
  return document.querySelector('meta[name="server-mediated-ai"]')?.content === 'true';
}

export function readingContentId() {
  return document.querySelector('#story-container')?.dataset?.contentId;
}

export function translationRequest(options) {
  return readingRequest('/langua/cartus_reading/translate', CONSUMER_TRANSLATION_URL, options);
}

export function wordInfoRequest(word, language, csrfToken, contextSentence, signal) {
  const options = { method: 'GET', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken } };
  if (!serverMediatedPage()) return fetch(`/langua/word_infos?word=${encodeURIComponent(word)}&language=${encodeURIComponent(language)}`, options);
  return readingRequest('/langua/cartus_reading/word_info', null, { ...options, signal, method: 'POST', body: JSON.stringify({ word, language, context_sentence: contextSentence }) });
}

function readingRequest(endpoint, consumerEndpoint, options) {
  if (!serverMediatedPage()) return fetch(consumerEndpoint, options);
  const csrf = document.querySelector('meta[name="csrf-token"]')?.content;
  if (!csrf) return Promise.reject(new Error('Reading session unavailable'));
  const body = JSON.parse(options.body);
  const contentId = readingContentId();
  if (contentId) body.content_id = contentId;
  if (document.querySelector('#story-container')?.dataset?.contentType === 'UserStory') {
    body.content_type = 'UserStory';
  }
  return fetch(endpoint, {
    ...options,
    credentials: 'same-origin',
    redirect: 'error',
    headers: { ...options.headers, 'X-CSRF-Token': csrf },
    body: JSON.stringify(body),
  });
}

// Escape only at HTML sinks; keep the response and flashcard values plain text.
export function readingHtml(value) {
  if (!serverMediatedPage()) return value;
  return String(value ?? '').replace(/[&<>"']/g, character => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  })[character]);
}
